import ImportationsApi from '../../apis/Importations';

export default {
    namespaced: true,
    state: {
        importations: [],
        importation_response: null
    },
    mutations: {
        set_importations (state, data) {
            state.importations = data;
        },
        set_importation_response (state, value) {
            state.importation_response = value;
        }
    },
    actions: {
        async getImportations ({commit}, filters) {
            return await ImportationsApi.get_all(filters)
                .then( response => {
                    commit('set_importations', response.data);
                }).catch( error => {
                    commit('set_importation_response', 'error');
                })
        },
        async store ({commit}, importation) {
            return await ImportationsApi.store(importation)
                .then( response => {
                    commit('set_importation_response', 'success');
                }).catch( error => {
                    commit('set_importation_response', 'error');
                })
        }
    }
}